import React from "react";

/**
 * Section card on a detail page. Pass label/value pairs as <DetailRow>
 * children, or arbitrary content (table, etc.) for related sections.
 */
const DetailSection = ({ title, children }) => {
  return (
    <section className="detail-section">
      {title && <header className="detail-section__header">{title}</header>}
      <div className="detail-section__body">{children}</div>
    </section>
  );
};

export const DetailRow = ({ label, children, mono }) => {
  const isEmpty =
    children === undefined ||
    children === null ||
    (typeof children === "string" && children.trim() === "");
  return (
    <div className="detail-row">
      <div className="detail-row__label">{label}</div>
      <div
        className={`detail-row__value${
          mono ? " detail-row__value--mono" : ""
        }${isEmpty ? " detail-row__value--empty" : ""}`}
      >
        {isEmpty ? "—" : children}
      </div>
    </div>
  );
};

export default DetailSection;
